/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CapabilityUpdateApiModel { 
    id: number;
    mandatory: boolean;
    overrideMonthInterval?: number | null;
}

